import {
  APP_INITIALIZER,
  EnvironmentProviders,
  makeEnvironmentProviders,
} from '@angular/core';
import { ThemeService } from '@mds/ngx-core';

export function provideForceLightTheme(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: APP_INITIALIZER,
      useFactory: (theme: ThemeService) => () => {
        if (theme.$isDarkMode()) theme.toggleTheme();
      },
      deps: [ThemeService],
      multi: true,
    },
  ]);
}
